import { TableCell, TableRow, Typography } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { formatWorkingDays } from "../format-utils"
import { CostFigure } from "./cost-figure"
import { getCapacityHoursPerDay, getFixedContractCapacity } from "./fixed-contract-capacity"
import { FixedContractCapacityCell } from "./fixed-contract-capacity-cell"
import { formatContractDaysExact } from "./format-contract-days"

export function FixedContractRow({ item, currencySymbol, capacity, showCapacity }) {
    const assessment = getFixedContractCapacity(item, capacity)
    return (
        <TableRow data-cy="fixed-contract-row">
            <TableCell>{item.tradeName}</TableCell>
            <TableCell align="right">{item.taskCount ?? 0}</TableCell>
            <TableCell align="right">{formatWorkingDays(item.hours || 0, getCapacityHoursPerDay(capacity))}</TableCell>
            <If value={showCapacity}>
                <TableCell align="right" data-cy="fixed-contract-contracted-days">
                    <If value={!!assessment}>
                        {formatContractDaysExact(assessment?.contractedDays)}
                        <Else>
                            <Typography variant="body2" color="text.secondary" component="span">
                                —
                            </Typography>
                        </Else>
                    </If>
                </TableCell>
                <TableCell align="right">
                    <If value={!!assessment}>
                        <FixedContractCapacityCell assessment={assessment} currencySymbol={currencySymbol} />
                        <Else>
                            <Typography variant="body2" color="warning.dark">
                                Not assessed — no contracted days
                            </Typography>
                        </Else>
                    </If>
                </TableCell>
            </If>
            <TableCell align="right">
                <CostFigure value={item.amount || 0} currencySymbol={currencySymbol} />
            </TableCell>
        </TableRow>
    )
}
